(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-badges"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('coupon-badge')) return;

    const copyText = async (text) => {
      try {
        await navigator.clipboard.writeText(text);
        return true;
      } catch (error) {
        // Fallback for browsers/contexts without the async clipboard API.
        const field = document.createElement('textarea');
        field.value = text;
        field.setAttribute('readonly', '');
        field.style.cssText = 'position:fixed;opacity:0;pointer-events:none';
        document.body.append(field);
        field.select();
        const copied = document.execCommand('copy');
        field.remove();
        return copied;
      }
    };

    class CouponBadge extends HTMLElement {
      connectedCallback() {
        if (!this.dataset.code) return;
        this.handleClick = (event) => {
          // The badge sits inside the card's product link.
          event.preventDefault();
          event.stopPropagation();
          this.copy();
        };
        this.addEventListener('click', this.handleClick);
      }

      disconnectedCallback() {
        if (this.handleClick) this.removeEventListener('click', this.handleClick);
        clearTimeout(this.resetTimer);
      }

      async copy() {
        if (!(await copyText(this.dataset.code))) return;

        const hint = this.querySelector('[data-coupon-hint]');
        const status = this.querySelector('[data-coupon-status]');

        this.classList.add('is-copied');
        if (hint) hint.textContent = 'Copiado!';
        if (status) status.textContent = `Cupom ${this.dataset.code} copiado`;

        clearTimeout(this.resetTimer);
        this.resetTimer = setTimeout(() => {
          this.classList.remove('is-copied');
          if (hint) hint.textContent = 'Copiar';
          if (status) status.textContent = '';
        }, 2000);
      }
    }

    customElements.define('coupon-badge', CouponBadge);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card-favorite"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('favorite-button')) return;

    const STORAGE_KEY = 'carraro:favoritos';

    const read = () => {
      try {
        const list = JSON.parse(localStorage.getItem(STORAGE_KEY));
        return Array.isArray(list) ? list : [];
      } catch (error) {
        return [];
      }
    };

    const write = (list) => {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      } catch (error) {
        // Storage can be blocked (e.g. private mode); favorites then are not kept.
      }
      document.dispatchEvent(new CustomEvent('favorites:change', { detail: { list } }));
    };

    window.CarraroFavorites = { STORAGE_KEY, read, write };

    class FavoriteButton extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.handleClick = (event) => {
          // The heart sits inside the card's product link.
          event.preventDefault();
          event.stopPropagation();
          this.toggle();
        };
        this.handleChange = () => this.update();
        this.handleStorage = (event) => {
          if (event.key === STORAGE_KEY) this.update();
        };

        this.button.addEventListener('click', this.handleClick);
        document.addEventListener('favorites:change', this.handleChange);
        window.addEventListener('storage', this.handleStorage);
        this.update();
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.handleClick);
        document.removeEventListener('favorites:change', this.handleChange);
        window.removeEventListener('storage', this.handleStorage);
      }

      toggle() {
        const handle = this.dataset.productHandle;
        const current = read();
        const list = current.filter((item) => item !== handle);
        if (list.length === current.length) list.unshift(handle);
        write(list);
      }

      update() {
        const isFavorite = read().includes(this.dataset.productHandle);
        this.button.setAttribute('aria-pressed', String(isFavorite));
        this.button.setAttribute('aria-label', isFavorite ? this.dataset.labelRemove : this.dataset.labelAdd);
      }
    }

    customElements.define('favorite-button', FavoriteButton);
  })();
  } catch(e) { console.error(e); }
})();

})();
